import { CollisionEvent, SimulationConfig } from '../../../types';

export type CollisionAnimationFn = (
  ctx: CanvasRenderingContext2D,
  e: CollisionEvent,
  config: SimulationConfig,
  progress: number,
  elapsed: number,
  globalHue: number,
  determineColor: (idx: number, total: number) => string
) => void;

export const COLLISION_ANIMATIONS: Record<string, CollisionAnimationFn> = {};

export const registerCollisionAnimation = (type: string, fn: CollisionAnimationFn) => {
  COLLISION_ANIMATIONS[type] = fn;
};
